import { useLocale } from 'next-intl'

import { cn } from '@/shared/lib'
import { Image } from '@/shared/ui'

import EnglishPreferredLandlord from '../asset/preferred-landlord-en.png'
import PreferredLandlord from '../asset/preferred-landlord.png'

type Props = {
  width?: number
  height?: number
  className?: string
}

export const SuperHostBadge = ({
  width: widthProp,
  height: heightProp,
  className,
}: Props) => {
  const t = useLocale()
  const englishWidth = widthProp ?? 114
  const width = widthProp ?? 64
  const height = heightProp ?? 22

  if (t === 'en')
    return (
      <Image
        src={EnglishPreferredLandlord}
        alt="Preferred Landlord"
        width={englishWidth}
        height={height}
        className={cn('rounded-xs', className)}
        external={false}
      />
    )

  return (
    <Image
      src={PreferredLandlord}
      alt="Preferred Landlord"
      width={width}
      height={height}
      className={cn('rounded-xs', className)}
      external={false}
    />
  )
}
